/**
 * Stock photo URLs for the CyberWise Corp website.
 * All photos sourced from Unsplash (free, no attribution required for commercial use).
 * Uses Unsplash CDN with on-the-fly resizing via ?w= parameter.
 *
 * To replace a photo: swap the URL. To host locally: download and update the path.
 */

const U = 'https://images.unsplash.com/photo-';

const photos = {
  // Hero backgrounds (w=1600 for full-width)
  heroes: {
    landing: `${U}1531482615713-2afd69097998?w=1600&q=80`,       // team collaborating on laptop
    about: `${U}1522071820081-009f0129c71c?w=1600&q=80`,         // diverse team in modern office
    careers: `${U}1523240795612-9a054b0db644?w=1600&q=80`,       // students working on laptops
    homeAssessment: '/images/site/home-hero.jpg',                   // suburban neighborhood
    businessAssessment: '/images/site/business-hero.jpg',              // small business owners
  },

  // Landing page
  landing: {
    empowerStudents: '/images/site/empower-students.jpg',             // woman with cyber security hologram
    expertWisdom: '/images/site/expert-wisdom.jpg',                   // CWC team reviewing reports (has CyberWiseCorp.com on screen)
    smartInvestment: '/images/site/smart-investment.jpg',             // graduation ceremony
    stepBook: '/images/site/step-book.jpg',                           // online booking concept
    stepMeet: '/images/site/step-meet.jpg',                           // diverse college interns group
    stepReview: '/images/site/step-review.jpg',                       // expert reviewing security data
    stepReport: '/images/site/step-report.jpg',                       // cyber shield security certificate
  },

  // About page
  about: {
    cissp: '/images/site/CISSP Certified.jpg',                          // CISSP certificate holders at table
    credentials: '/images/site/Stacked Credentials.png',                // wall of framed cybersecurity certs
    experienced: '/images/site/Ten Years Experience.jpg',               // experienced team in boardroom
    mentors: '/images/site/Active Mentors.jpg',                         // mentor pointing at security dashboard with student
    internPerforms: '/images/site/Intern Performs.jpg',               // student performing assessment
    expertReviews: `${U}1542744173-8e7e53415bb0?w=600&q=80`,        // professional at workstation
    mentorCoaches: '/images/site/Mentor Coaches.jpg',                 // mentor coaching student
  },

  // Careers page
  careers: {
    earnings: `${U}1552664730-d307ca884978?w=600&q=80`,             // professional celebrating
    mentorship: `${U}1531482615713-2afd69097998?w=600&q=80`,        // mentoring at computer
    resume: `${U}1573497019236-17f8177b81e8?w=600&q=80`,            // professional handshake/meeting
    growth: `${U}1552664730-d307ca884978?w=600&q=80`,               // career growth celebration
    flexible: `${U}1498050108023-c5249f4df085?w=600&q=80`,          // student with laptop casually
    network: `${U}1556761175-5973dc0f32e7?w=600&q=80`,              // professionals networking
  },

  // Home assessment page
  homeAssessment: {
    networkSecurity: '/images/site/home-network.jpg',                // home WiFi router on shelf
    deviceSecurity: '/images/site/baby-monitor.jpg',                  // baby with unsecured monitor
    dataSecurity: '/images/site/data-protection.jpg',                // backup status, cloud audit, ransomware recovery
    userAwareness: '/images/site/user-awareness.jpg',                // passwords, phishing, MFA
  },

  // Business assessment page
  businessAssessment: {
    networkInfra: `${U}1558494949-ef010cbdcc31?w=600&q=80`,         // server room / network cables
    endpoints: `${U}1497366216548-37526070297c?w=600&q=80`,         // office workstations
    businessSystems: `${U}1556742049-0cfed4f6a45d?w=600&q=80`,     // POS system
    employeeAccess: `${U}1522071820081-009f0129c71c?w=600&q=80`,    // team in office
    dataProtection: `${U}1558494949-ef010cbdcc31?w=600&q=80`,       // data center
    compliance: `${U}1552664730-d307ca884978?w=600&q=80`,            // meeting/compliance
  },
};

export default photos;
